import { useState, useEffect } from "react"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { RefreshCw } from "lucide-react"
import { Button } from "@/components/ui/button"

interface SimpleCaptchaProps {
  onVerify: (isValid: boolean) => void
  onReset?: () => void
}

export function SimpleCaptcha({ onVerify, onReset }: SimpleCaptchaProps) {
  const [num1, setNum1] = useState(0)
  const [num2, setNum2] = useState(0)
  const [operator, setOperator] = useState("+")
  const [userAnswer, setUserAnswer] = useState("")
  const [correctAnswer, setCorrectAnswer] = useState(0)

  const generateQuestion = () => {
    const operators = ["+", "-", "×"]
    const selectedOperator = operators[Math.floor(Math.random() * operators.length)]
    
    let n1, n2, answer
    
    if (selectedOperator === "+") {
      n1 = Math.floor(Math.random() * 20) + 1
      n2 = Math.floor(Math.random() * 20) + 1
      answer = n1 + n2
    } else if (selectedOperator === "-") {
      // Ensure positive result
      n1 = Math.floor(Math.random() * 20) + 10
      n2 = Math.floor(Math.random() * n1) + 1
      answer = n1 - n2
    } else { // multiplication
      n1 = Math.floor(Math.random() * 10) + 1
      n2 = Math.floor(Math.random() * 10) + 1
      answer = n1 * n2
    }
    
    setNum1(n1)
    setNum2(n2)
    setOperator(selectedOperator)
    setCorrectAnswer(answer)
    setUserAnswer("")
  }

  useEffect(() => {
    generateQuestion()
  }, [])

  useEffect(() => {
    if (userAnswer) {
      const isCorrect = parseInt(userAnswer) === correctAnswer
      onVerify(isCorrect)
    } else {
      onVerify(false)
    }
  }, [userAnswer, correctAnswer, onVerify])

  const handleRefresh = () => {
    generateQuestion()
    onReset?.()
  }

  return (
    <div className="space-y-2">
      <Label>Verify you're human</Label>
      <div className="flex items-center gap-2 p-3 bg-muted/50 rounded-md border">
        <div className="flex items-center gap-2 text-lg font-mono">
          <span>{num1}</span>
          <span>{operator}</span>
          <span>{num2}</span>
          <span>=</span>
          <Input
            type="number"
            value={userAnswer}
            onChange={(e) => setUserAnswer(e.target.value)}
            placeholder="?"
            className="w-20 text-center"
            required
          />
        </div>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={handleRefresh}
          className="ml-auto"
        >
          <RefreshCw className="h-4 w-4" />
        </Button>
      </div>
      <p className="text-xs text-muted-foreground">
        Solve the math problem to continue
      </p>
    </div>
  )
}